import { FC } from 'react'

type Props = {
  src: string
  title: string
  desc: string
}

const Component: FC<Props> = ({ src, title, desc }) => {
  return (
    <div className="flex flex-col lg:flex-row items-center">
      <img src={src} alt={title} className="object-contain" />
      <div className="flex flex-col items-center lg:items-start gap-4">
        <p className="text-xl">{title}</p>
        <p className="max-w-[270px]">{desc}</p>
      </div>
    </div>
  )
}

export default Component
